<atn-ds-centered-overlay>
  <atn-ds-widget
    [title]="titleSg()"
    class="add-record-dialog"
  >
    <div class="add-record-dialog__widget-content">
      @for (attr of attributesSg(); track $index) {
        @if (!nonEditableAttributeIds.includes(attr.id)) {
          <atn-display-value
            [type]="attr.type"
            [value]="recordValuesSg()[attr.id]"
            [label]="attr.name"
            (valueChange)="attributeValueChangeHandler(attr.id, $event)"
          />
        }
      }
      @if (entityParentSg()) {
        <!-- TODO: Maybe see if this component can be moved somewhere else in
        the files since it is used by edit-record-dialog also -->
        <atn-entity-record-select
          [entity]="entityParentSg()"
          [value]="recordParentIdSg()"
          (valueChange)="recordParentIdChangeHandler($event)"
        />
      }
    </div>
    <div
      footer
      class="add-record-dialog__footer"
    >
      <atn-ds-button
        class="add-record-dialog__footer-cancel-btn"
        type="transparent"
        (click)="cancelBtnClickHandler()"
        >Cancel</atn-ds-button
      >
      <atn-ds-button (click)="saveClickHandler()">Save</atn-ds-button>
    </div>
  </atn-ds-widget>
</atn-ds-centered-overlay>
